import React from "react";
import { Link } from "react-router-dom";
import { useFavorites } from "../context/FavoritesContext";
import { ArrowLeft, Trash2, ExternalLink } from "lucide-react";

const KINDS = [
  { k: "launch", label: "MISSIONS", to: (id) => `/launches/${id}` },
  { k: "rocket", label: "ROCKETS", to: (id) => `/fleet/${id}` },
  { k: "milestone", label: "MILESTONES", to: (_id, f) => f?.payload?.month ? `/history?m=${f.payload.month}` : "/history" },
  { k: "news", label: "TRANSMISSIONS", to: null },
  { k: "event", label: "EVENTS", to: null },
];

export default function ArchivePage() {
  const { favs, remove } = useFavorites();

  return (
    <div data-testid="page-archive">
      <Link to="/pilot" className="sat-label inline-flex items-center gap-2 mb-4 hover:sat-cyan" data-testid="back-pilot">
        <ArrowLeft size={14} /> BACK TO PILOT
      </Link>
      <div className="mb-6 border-b border-[color:var(--sat-border)] pb-4">
        <div className="sat-label sat-cyan">DIRECTIVE // ARCHIVE</div>
        <h1 className="font-display font-bold text-3xl md:text-4xl mt-1">MY ARCHIVE</h1>
        <p className="text-sm text-[color:var(--sat-text-dim)] mt-2">{favs.length} items in storage</p>
      </div>

      {favs.length === 0 ? (
        <div className="text-center py-16 sat-label">ARCHIVE EMPTY — TAP HEARTS TO STORE ITEMS</div>
      ) : (
        <div className="space-y-8">
          {KINDS.map(({ k, label, to }) => {
            const items = favs.filter(f => f.kind === k);
            if (items.length === 0) return null;
            return (
              <section key={k} data-testid={`archive-section-${k}`}>
                <div className="sat-label sat-cyan mb-3">{label} · {items.length}</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {items.map(f => {
                    const isExternal = k === "news" && f.payload?.url;
                    const body = (
                      <div className="sat-surface sat-brackets p-3 flex gap-3 items-center group hover:sat-box-glow">
                        <div className="w-16 h-16 bg-black flex-shrink-0">
                          {f.image ? <img src={f.image} alt="" className="w-full h-full object-cover" /> : null}
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-sm font-medium line-clamp-2 group-hover:text-[color:var(--sat-cyan)] transition-colors">{f.title}</div>
                          {isExternal && <div className="sat-label mt-1 flex items-center gap-1"><ExternalLink size={9} /> {f.payload?.news_site || "SOURCE"}</div>}
                        </div>
                        <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); remove(f.id); }}
                          className="p-2 border border-[color:var(--sat-border)] text-[color:var(--sat-text-dim)] hover:border-[color:var(--sat-danger)] hover:text-[color:var(--sat-danger)]"
                          data-testid={`archive-remove-${f.id}`}>
                          <Trash2 size={12} />
                        </button>
                      </div>
                    );
                    if (to) return <Link key={f.id} to={to(f.ref_id, f)} data-testid={`archive-item-${f.id}`}>{body}</Link>;
                    if (isExternal) return <a key={f.id} href={f.payload.url} target="_blank" rel="noopener noreferrer" data-testid={`archive-item-${f.id}`}>{body}</a>;
                    return <div key={f.id} data-testid={`archive-item-${f.id}`}>{body}</div>;
                  })}
                </div>
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
}
